import React from 'react'
import { RouteHandler, Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'
import SiteNav from '../SiteNav'
import SiteLinks from '../SiteLinks'
import './style.css'
import profilePic from '../../pages/images/photo.jpg'

class Footer extends React.Component {
    render() {
        const {location, children} = this.props
        const isHome = location.pathname === prefixLink('/')

        return (
              <footer className="footer">
                <h3>Contact</h3>
                <p>Let's do work that matters. Say hello anytime.</p>
                <SiteLinks {...this.props}/>
                <p className='copyright'>
                  Built with <i className="fa fa-heart" aria-hidden="true"></i> in NYC. © 2010 - 2018, <a title="Husam Machlovi | Product Strategy & Design" href="http://husammachlovi.com">Husam Machlovi | Product Strategy & Design.</a>
                </p>
              </footer>
            );
    }
}

Footer.propTypes = {
    children: React.PropTypes.any,
    location: React.PropTypes.object,
}

export default Footer



// WEBPACK FOOTER //
// ../components/Footer/index.jsx